import { NavigateFunction, Location } from 'react-router-dom';

export function closeGlobalDrawerRoute(
    navigate: NavigateFunction,
    location: Location
) {
    // Removed everything after and including /d/ from the current path
    navigate(location.pathname.replace(/(?:\/d\/\/?.*)/, ''));
}
